// slide.js
import { Splide } from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

/* iOS安定化: 属性だけでなくプロパティもセット */
function prepareVideo(video) {
 video.muted = true;
 video.autoplay = true;
 video.playsInline = true;
 video.setAttribute("playsinline", "");
 video.setAttribute("webkit-playsinline", "");
}

/* すべての動画を事前読み込み（2周目のカクつき防止） */
function preloadVideos() {
 const isSP = window.matchMedia("(max-width: 768px)").matches;
 document.querySelectorAll(".splide03__media").forEach((video) => {
   prepareVideo(video);
   const pc = video.dataset.srcPc;
   const sp = video.dataset.srcSp;
   const target = (isSP && sp) ? sp : pc;
   if (target) {
     video.src = target;
     if (!isSP) video.load(); // iOSでは.load()しない
   }
 });
}

/* アクティブ動画だけ再生 */
function playOnly(videos, activeIndex) {
 videos.forEach((v, i) => {
   prepareVideo(v);
   if (i === activeIndex) {
     v.currentTime = 0; // 常に先頭から再生（ズレ防止）
     const p = v.play();
     if (p && typeof p.catch === "function") p.catch(() => {});
   } else {
     try { v.pause(); } catch (_) {}
   }
 });
}

/* メイン関数 */
export function slide() {
 // ▼ 先に動画を事前読み込み
 preloadVideos();

 // ▼ splide01：静止画スライダー
 document.querySelectorAll(".splide01").forEach((el) => {
   new Splide(el, {
     type: "loop",
     perPage: 3,
     perMove: 1,
     autoplay: true,
     interval: 3000,
     pauseOnHover: false,
     focus: 0,
     breakpoints: { 768: { perPage: 1 } },
   }).mount();
 });

 // ▼ splide02：横スクロール
 document.querySelectorAll(".splide02").forEach((el) => {
   new Splide(el, {
     type: "loop",
     perPage: 3,
     focus: 0,
     autoScroll: { speed: 2 },
   }).mount({ AutoScroll });
 });

 // ▼ splide03：動画フェードスライダー（FV用）
 document.querySelectorAll(".splide03").forEach((el) => {
   const isSP = window.matchMedia("(max-width: 768px)").matches;

   const splide = new Splide(el, {
     type: "fade",
     autoplay: true,
     rewind: true,           // ✅ SPでも最初に戻す
     pauseOnHover: false,
     pauseOnFocus: false,
     arrows: false,
     pagination: false,
     interval: isSP ? 3985 : 3985, // SP4秒 / PC5秒
     speed: isSP ? 3985 : 3985,     // SPゆるめフェード
   });

   const videos = el.querySelectorAll(".splide03__media");

   splide.on("mounted", () => {
     playOnly(videos, splide.index);
   });

   splide.on("moved", (newIndex) => {
     playOnly(videos, newIndex);
   });

   // ✅ ループ最後→最初に戻る瞬間に動画もリセット
   splide.on("active", (slide) => {
     const index = slide.index;
     const total = videos.length;
     if (index === 0) {
       videos.forEach((v) => v.currentTime = 0);
     }
   });

   splide.mount();
 });

 // ▼ splide04：静止画スライダー
 document.querySelectorAll(".splide04").forEach((el) => {
   new Splide(el, {
     type: "loop",
     perPage: 3,
     perMove: 1,
     autoplay: true,
     interval: 3000,
     pauseOnHover: false,
     arrows: true,
     pagination: false,
     gap: 'min(72px, calc(72 / 1440 * 100vw))',
     focus: 0,
     breakpoints: { 768: { perPage: 1 } },
   }).mount();
 });
}



